import { takeLatest, put } from 'redux-saga/effects'
import {
  cancelDocumentRequest,
  getDocumentLabel,
  updateDocumentLabel,
  createDocumentLabel,
  requestDocument,
  getloyaltyLevel,
  updateloyaltyLevel,
  getAllSABanners,
  uploadSABanner,
  updateSABanner,
  updateSAUserStatus,
  deleteSABanners,
  sendEmailTemplate,
  getWelcomeBonus,
  updateWelcomeBonus,
  getAffiliateRequests,
  updateAffiliateStatus,
  getBankingDetails,
  createBankingDetails,
  updateBankingDetails,
  deleteBankingDetails,
  verifyOrMarkSuspiciousUser,
  updateBankingDetailsStatus
} from '../../utils/apiCalls'
import {
  getDocumentLabelStart,
  getDocumentLabelSuccess,
  getDocumentLabelFailure,
  updateDocumentLabelStart,
  updateDocumentLabelComplete,
  createDocumentLabelStart,
  createDocumentLabelComplete,
  updateDocumentStart,
  updateDocumentComplete,
  getloyaltyLevelStart,
  getloyaltyLevelSuccess,
  getloyaltyLevelFailure,
  updateloyaltyLevelStart,
  updateloyaltyLevelComplete,
  getAllSABannersStart,
  getAllSABannersSuccess,
  getAllSABannersFailure,
  uploadSABannerStart,
  uploadSABannerComplete,
  updateSABannerStart,
  updateSABannerComplete,
  updateSAUserStatusStart,
  updateSAUserStatusCompleted,
  updateSAUserStatusFailure,
  deleteSABannersSuccess,
  deleteSABannersFailure,
  deleteSABannersStart,
  sendEmailStart,
  sendEmailCompleted,
  sendEmailFailure,
  getWelcomeBonusStart,
  getWelcomeBonusSuccess,
  getWelcomeBonusFailure,
  updateWelcomeBonusStart,
  updateWelcomeBonusComplete,
  updateWelcomeBonusFailuire,
  getAllAffiliateStart,
  getAllAffiliateSuccess,
  getAllAffiliateFailure,
  updateAffiliateStatusStart,
  updateAffiliateStatusComplete,
  updateAffiliateStatusFailuire,
  getBankingDetailsSuccess,
  getBankingDetailsFailure,
  getBankingDetailsStart,
  createBankingDetailsComplete,
  createBankingDetailsFailure,
  createBankingDetailsStart,
  updateBankingDetailsComplete,
  updateBankingDetailsFailure,
  updateBankingDetailsStart,
  deleteBankingDetailsComplete,
  deleteBankingDetailsFailure,
  deleteBankingDetailsStart,
  verifyOrMarkSuspiciousUserCompleted,
  verifyOrMarkSuspiciousUserFailure,
  verifyOrMarkSuspiciousUserStart,
  updateBankingDetailsStatusOptimistic,
  updateBankingDetailsStatusFailure,
  updateBankingDetailsStatusStart,
  updateBankingDetailsStatusComplete
} from '../redux-slices/superAdminSettings'
import { toast } from '../../components/Toast'
import { getSAUserDocumentStart, getUserStart } from '../redux-slices/fetchData'
import { getTenantStart } from '../redux-slices/tenants'
import { serialize } from 'object-to-formdata'

export default function* superAdminSettingsWatcher() {
  yield takeLatest(getDocumentLabelStart.type, getDocumentLabelWorker)
  yield takeLatest(updateDocumentLabelStart.type, updateDocumentLabelWorker)
  yield takeLatest(createDocumentLabelStart.type, createDocumentLabelWorker)
  yield takeLatest(updateDocumentStart.type, updateDocumentWorker)
  yield takeLatest(getloyaltyLevelStart.type, getloyaltyLevelWorker)
  yield takeLatest(updateloyaltyLevelStart.type, updateloyaltyLevelWorker)
  yield takeLatest(updateWelcomeBonusStart.type, updateWelcomeBonusWorker)
  yield takeLatest(getAllSABannersStart.type, getAllSABannersWorker)
  yield takeLatest(getAllAffiliateStart.type, getAllAffiliateWorker)
  yield takeLatest(getWelcomeBonusStart.type, getWelcomeBonusWorker)
  yield takeLatest(deleteSABannersStart.type, deleteSABannersWorker)
  yield takeLatest(updateSABannerStart.type, updateSABannerWorker)
  yield takeLatest(updateAffiliateStatusStart.type, updateAffiliateStatusWorker)
  yield takeLatest(uploadSABannerStart.type, uploadSABannerWorker)
  yield takeLatest(updateSAUserStatusStart.type, updateSAUserUpdateWorker)
  yield takeLatest(sendEmailStart.type, sendEmailStartWorker)
  yield takeLatest(getBankingDetailsStart.type, getBankingDetailsWorker)
  yield takeLatest(createBankingDetailsStart.type, createBankingDetailsWorker)
  yield takeLatest(updateBankingDetailsStart.type, updateBankingDetailsWorker)
  yield takeLatest(deleteBankingDetailsStart.type, deleteBankingDetailsWorker)
  yield takeLatest(verifyOrMarkSuspiciousUserStart.type, verifyOrMarkSuspiciousUserWorker)
  yield takeLatest(updateBankingDetailsStatusStart.type, updateBankingDetailsStatusWorker)
}

function* getDocumentLabelWorker(action) {
  try {
    const { userId } = action && action.payload

    const { data } = yield getDocumentLabel(userId)

    yield put(getDocumentLabelSuccess(data?.data?.documentLabel))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getDocumentLabelFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateDocumentLabelWorker(action) {
  try {
    const { data } = action && action.payload

    yield updateDocumentLabel(data)

    yield put(updateDocumentLabelComplete())
    yield toast('Labels Updated SuccessFully', 'success')
    yield put(getDocumentLabelStart({ userId: '' }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateDocumentLabelComplete())
  }
}

function* createDocumentLabelWorker(action) {
  try {
    const { data } = action && action.payload

    yield createDocumentLabel(data)

    yield put(createDocumentLabelComplete())
    yield toast('Label Created SuccessFully', 'success')
    yield put(getDocumentLabelStart({ userId: '' }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(createDocumentLabelComplete())
  }
}

function* updateDocumentWorker(action) {
  try {
    const { data, isRequested } = action && action.payload

    isRequested ? yield requestDocument(data) : yield cancelDocumentRequest(data)

    yield updateDocumentComplete()
    yield put(getUserStart({ userId: data?.userId }))
    yield put(getSAUserDocumentStart({ userId: data?.userId }))
    yield put(getDocumentLabelStart({ userId: data?.userId }))

    yield toast(`Document ${isRequested ? 'Requested' : 'UnRequested'} Successfully`, 'success')
  } catch (e) {
    yield updateDocumentComplete()

    yield toast(e?.response?.data?.errors[0]?.description, 'error')
  }
}

function* getloyaltyLevelWorker(action) {
  try {
    const { isTenant, tenantId } = action && action.payload

    const { data } = yield getloyaltyLevel({ isTenant, tenantId: tenantId || '' })

    yield put(getloyaltyLevelSuccess(data?.data?.loyaltyLevel))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getloyaltyLevelFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateloyaltyLevelWorker(action) {
  try {
    const { loyaltyLevel, isTenant, tenant = false, tenantId = '' } = action && action.payload

    yield updateloyaltyLevel({ isTenant, data: { loyaltyLevel: loyaltyLevel?.loyaltyLevel, tenantId } })

    yield put(updateloyaltyLevelComplete())

    yield toast('Data Updated SuccessFully', 'success')
    if (tenant) yield put(getTenantStart({ tenantId }))
    else yield put(getloyaltyLevelStart({ isTenant }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateloyaltyLevelComplete())
  }
}

function* updateWelcomeBonusWorker(action) {
  try {
    const { bonusTimes, userId } = action && action.payload

    console.log('wecomeBonus saga', bonusTimes, userId);

    yield updateWelcomeBonus({ data: { bonusTimes: bonusTimes, userId: userId } })

    yield put(updateWelcomeBonusComplete())

    yield put(getUserStart({ userId: userId }))

    yield toast('Data Updated SuccessFully', 'success')
    yield put(getWelcomeBonusStart({}))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateWelcomeBonusFailuire())
  }
}

function* getAllSABannersWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload

    const { data } = yield getAllSABanners({ limit, pageNo })

    yield put(getAllSABannersSuccess(data?.data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getAllSABannersFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getBankingDetailsWorker(action) {
  try {
    const { limit, pageNo, bankType } = action && action.payload
    const { data } = yield getBankingDetails({ limit, pageNo, bankType })

    yield put(getBankingDetailsSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getBankingDetailsFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* createBankingDetailsWorker(action) {
  try {
    const { onSuccess, ...data } = action && action.payload

    const response = yield createBankingDetails(data)


    if (response?.data?.errors?.length > 0) {

      yield toast(response?.data?.errors[0]?.description || response?.data?.errors[0]?.message, 'error')

      yield put(createBankingDetailsFailure())
    }
    else {
      yield put(createBankingDetailsComplete())

      yield toast('Banking details created successfully', 'success')
      if (onSuccess) {
        yield onSuccess()
      }
    }

  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(createBankingDetailsFailure())
  }
}

function* updateBankingDetailsWorker(action) {
  try {
    const { onSuccess, ...data } = action && action.payload

    yield updateBankingDetails(data)
    yield put(updateBankingDetailsComplete())
    yield toast('Banking details updated successfully', 'success')

    if (onSuccess) {
      yield onSuccess()
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateBankingDetailsFailure())
  }
}

function* updateBankingDetailsStatusWorker(action) {
  const { onSuccess, data, optimisticUpdate, previousStatus } = action && action.payload
  try {
    if (optimisticUpdate) {
      yield put(updateBankingDetailsStatusOptimistic({
        bankDetailsId: data?.bankDetailsId,
        newStatus: data?.status
      }))
    }

    yield updateBankingDetailsStatus(data)
    yield put(updateBankingDetailsStatusComplete())
    yield toast('Banking details updated successfully', 'success')

    if (onSuccess) {
      yield onSuccess()
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateBankingDetailsStatusFailure({
      bankDetailsId: data?.bankDetailsId,
      status: previousStatus
    }))
  }
}

function* deleteBankingDetailsWorker(action) {
  try {
    const { onSuccess, ...data } = action && action.payload

    yield deleteBankingDetails(data)
    yield put(deleteBankingDetailsComplete())
    yield toast('Banking details deleted successfully', 'success')

    if (onSuccess) {
      yield onSuccess()
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(deleteBankingDetailsFailure())
  }
}

function* getAllAffiliateWorker(action) {
  try {
    const { limit, pageNo, isAffiliateUpdated = false } = action && action.payload

    const { data } = yield getAffiliateRequests({ limit, pageNo, isAffiliateUpdated })


    yield put(getAllAffiliateSuccess(data?.data?.userDocument))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getAllAffiliateFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getWelcomeBonusWorker(action) {
  try {
    const { data } = yield getWelcomeBonus({})
    console.log('welcome bonus', data?.data?.bonus);

    yield put(getWelcomeBonusSuccess(data?.data?.bonus))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getWelcomeBonusFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* deleteSABannersWorker(action) {
  try {
    const { name } = action && action.payload

    const { data } = yield deleteSABanners({ name })
    yield toast('Banner Deleted SuccessFully', 'success')
    yield put(deleteSABannersSuccess(data?.data))
    yield put(getAllSABannersStart({
      limit: 15,
      pageNo: 1,
    }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(deleteSABannersFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateSABannerWorker(action) {
  try {
    const { data: banner, limit, pageNo } = action && action.payload
    const data = serialize(banner)
    console.log({ data, action }, "saga banerrerere")
    if (banner?.image) {
      yield updateSABanner(data)
    }

    yield put(updateSABannerComplete())

    yield toast('Banner Updated SuccessFully', 'success')
    yield put(getAllSABannersStart({
      limit,
      pageNo,
      adminId: '',
      tenantId: ''
    }))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateSABannerComplete())
  }
}

function* updateAffiliateStatusWorker(action) {
  try {
    const { data, limit, pageNo, status = '', affiliiateUser = false } = action && action.payload

    yield updateAffiliateStatus(data)

    yield put(updateAffiliateStatusComplete())

    yield toast('Affiliate Status Updated SuccessFully', 'success')
    yield put(getUserStart({ userId: data.userId }))
    if (affiliiateUser) {
      yield put(getAllAffiliateStart({
        limit,
        pageNo,
        status
      }))
    } else {
      yield put(getAllAffiliateStart({
        limit,
        pageNo,
        status
      }))
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateAffiliateStatusFailuire())
  }
}

function* uploadSABannerWorker(action) {
  try {
    const { data: banner, limit, pageNo } = action && action.payload
    const data = serialize(banner)

    const response = yield uploadSABanner(data)


    if (response?.data?.data?.bannerCreated) {
      yield put(uploadSABannerComplete())
      yield toast('Banner Uploaded SuccessFully', 'success')
      yield put(getAllSABannersStart({
        limit,
        pageNo,
        adminId: '',
        tenantId: ''
      }))
    }
    else {
      yield toast(response?.data?.data?.message, 'error')

      yield put(uploadSABannerComplete())
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(uploadSABannerComplete())
  }
}

function* updateSAUserUpdateWorker(action) {
  try {
    const { data } = action && action.payload

    yield updateSAUserStatus({ ...data })
    yield toast('User Status Updated SuccessFully', 'success')
    yield put(updateSAUserStatusCompleted())
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateSAUserStatusFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* sendEmailStartWorker(action) {
  try {
    const { data } = action && action.payload

    yield sendEmailTemplate({ ...data })
    yield toast('Email sent successfully', 'success')
    yield put(updateSAUserStatusCompleted())
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateSAUserStatusFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* verifyOrMarkSuspiciousUserWorker(action) {
  try {
    const { data } = action && action.payload

    yield verifyOrMarkSuspiciousUser({ ...data })

    let message = ''

    if (data.verified) {
      message = 'User verified successfully'
    } else {
      message = data.suspicious ? 'User has been marked suspicious' : 'User has been marked trusted'
    }

    yield toast(message, 'success')
    yield put(verifyOrMarkSuspiciousUserCompleted())
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(verifyOrMarkSuspiciousUserFailure(e?.response?.data?.errors[0]?.description))
  }
}
